import { COUNTRY_CODES } from "utils/countryCodes"

export interface SelectOption<T = string> {
  label: string
  value: T
}

export const getCountrySelectOptions = (): SelectOption[] => {
  return COUNTRY_CODES.map(({ code, name }) => ({
    label: `${name} (${code})`,
    value: code,
  }))
}


export const getAvailableCountryOptions = (excludeCodes: string[]): SelectOption[] => {
  return COUNTRY_CODES
    .filter(({ code }) => !excludeCodes.includes(code))
    .map(({ code, name }) => ({
      label: `${name} (${code})`,
      value: code,
    }))
}

export const getCountryOptionsFromCodes = (codes: string[]): SelectOption[] => {
  return codes.map(code => {
    const country = COUNTRY_CODES.find(c => c.code === code)

    return {
      label: country ? `${country.name} (${code})` : code,
      value: code,
    }
  })
}
